// buildしたときmain.jsを吐くように、１つ以上scriptが必要。